<script setup>
import { computed } from "vue";

  const props = defineProps({
    loteStore: Object,
});

const caracteristicasFiltradas = computed(() => {
  return props.loteStore.lote?.caracteristicas?.filter(c => c.value) || [];
});

</script>

<template>
  <div class="card p-4 mb-5">
    <h5 class="fw-bold mb-3">Ficha</h5>
    
    <div v-for="(caracteristica, index) in caracteristicasFiltradas" :key="index" class="row mb-2">
      <div class="col-4 col-md-2 fw-400 text-black">
        {{ caracteristica.key }}
      </div>
      <div class="col-8 col-md-10 fw-700 text-black">
        {{ caracteristica.value }}
      </div>
    </div>
  </div>
</template>
